import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, skipOnboardingCheck = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <p className="font-mono text-xs text-zinc-500 uppercase tracking-widest">Loading…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  // Force onboarding for runners who haven't finished it
  if (!skipOnboardingCheck && user.role === "runner" && user.onboarding_complete === false) {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
}
